<template>
  <v-btn
    :class="classes"
    :color="buttonType"
    :outlined="outlined"
    :href="link.url"
    :target="link.target"
    :title="link.title"
    rounded
    :elevation="$attrs.elevation || '0'"
    v-bind="{ ...$attrs, ...$props }"
    @click="$emit('base-click')"
  >
    <slot />
  </v-btn>
</template>

<script>
import { indexOf, values } from 'lodash-es'
import { typo3LinkProps } from '@/js/helper/links-helper.js'

import API_CONSTANTS from '@/js/helper/api-constants.js'

const allowedButtonTypes = {
  PRIMARY: API_CONSTANTS.CTA.TYPES.PRIMARY,
  SECONDARY: API_CONSTANTS.CTA.TYPES.SECONDARY,
  BLACK: API_CONSTANTS.CTA.TYPES.BLACK,
  ERROR: API_CONSTANTS.CTA.TYPES.ERROR,
}
const defaultButtonType = allowedButtonTypes.PRIMARY

export default {
  name: 'BaseButton',
  // ToDo: Change prop because we need type
  props: {
    type: {
      type: String,
      default: defaultButtonType,
    },
    href: {
      type: [String, Object],
      default: undefined,
    },
  },
  computed: {
    classes() {
      return [
        'btn',
        {
          'btn--border-black': this.type === allowedButtonTypes.BLACK,
        },
        'text-center',
      ]
    },
    outlined() {
      return this.$attrs.outlined || this.type === allowedButtonTypes.SECONDARY
    },
    buttonType() {
      const allowedButtonTypesValues = values(allowedButtonTypes)

      if (indexOf(allowedButtonTypesValues, this.type) > 0) {
        return this.type
      }

      return defaultButtonType
    },
    link() {
      return typo3LinkProps(this.href)
    },
  },
}
</script>
